import {createStaticRanges} from "react-date-range";
import moment from "dayjs";
import {KeyConstant} from "../constant/keyConstant";
import {t} from "i18next";
import {Translation} from "react-i18next";

export const staticRanges = createStaticRanges([
    {
        label: <Translation>{(t) =>t("tnp.components.report.today")}</Translation>,
        range: () => ({
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            text: KeyConstant.TODAY
        })
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.yesterday")}</Translation>,
        range: () => ({
            startDate: moment().subtract(1, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.YESTERDAY
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.thisWeek")}</Translation>,
        range: () => ({
            startDate: moment().startOf("week").toDate(),
            endDate: moment().endOf("week").toDate(),
            text: KeyConstant.THIS_WEEK
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.lastWeek")}</Translation>,
        range: () => ({
            startDate: moment().subtract(1, "weeks").startOf("week").toDate(),
            endDate: moment().subtract(1, "weeks").endOf("week").toDate(),
            text: KeyConstant.LAST_WEEK
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.thisMonth")}</Translation>,
        range: () => ({
            startDate: moment().startOf("month").toDate(),
            endDate: moment().endOf("month").toDate(),
            text: KeyConstant.THIS_MONTH
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.lastMonth")}</Translation>,
        range: () => ({
            startDate: moment().subtract(1, "months").startOf("month").toDate(),
            endDate: moment().subtract(1, "months").endOf("month").toDate(),
            text: KeyConstant.LAST_MONTH
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.sevenDayAgo")}</Translation>,
        range: () => ({
            startDate: moment().subtract(7, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.SEVEN_DAYS_AGO
        }),
    },
    {
        label: <Translation>{(t) =>t("tnp.components.report.twentyEightDayAgo")}</Translation>,
        range: () => ({
            startDate: moment().subtract(28, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.THIRTY_DAYS_AGO
        }),
    },
    {
        label:  <Translation>{(t) =>t("tnp.components.report.ninetyDayAgo")}</Translation>,
        range: () => ({
            startDate: moment().subtract(90, "days").toDate(),
            endDate: moment().subtract(1, "days").toDate(),
            text: KeyConstant.NINETY_DAYS_AGO
        }),
    }
]);
